import React, {useState} from 'react';
import styles from "./styles.module.scss";
import SearchTypeToggler from './components/SearchTypeToggler';
import SingleSearchInput from './components/SingleSearchInput';
import BulkSearchForm from './components/BulkSearchForm';

const SingleBulkSearchPanel = ({
    panelHeading = 'Search Students',
    singleSearchParams = [],
    bulkSearchFormFields = [],
    searchBtnTxt = "Search",
    bulkSearchForm,
    bulkSearchFormHandler,
    searchHandler,
    isSearchBtnDisabled
}) => {
    const [isBulkSearch , setIsBulkSearch] = useState(false);

    return ( 
        <div className={`${styles['panel-container']}`}>

            <div className={`${styles['panel-heading']}`}>{panelHeading}</div>

            <SearchTypeToggler isBulkSearch={isBulkSearch} setIsBulkSearch={setIsBulkSearch}/>

            <SingleSearchInput 
            searchParams={singleSearchParams}
            searchHandler={searchHandler}
            isBulkSearch={isBulkSearch}
            />

            <BulkSearchForm
             formFields={bulkSearchFormFields} 
             searchBtnTxt={searchBtnTxt} 
             form={bulkSearchForm}
             formHandler={bulkSearchFormHandler}
             searchHandler={searchHandler}
             isBulkSearch={isBulkSearch}
             isSearchBtnDisabled={isSearchBtnDisabled}
             />

        </div>
     );
}
 
export default SingleBulkSearchPanel;